import { render, staticRenderFns } from "./StudentCreateNoteModal.vue?vue&type=template&id=d27400a8&scoped=true&"
import script from "./StudentCreateNoteModal.vue?vue&type=script&lang=js&"
export * from "./StudentCreateNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentCreateNoteModal.vue?vue&type=style&index=0&id=d27400a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27400a8",
  null
  
)

export default component.exports